const CheckNegative = (value) => {
  return value < 0 ? true : false;
};
const Validator = {
  CheckNegative,
};
export default Validator;
